var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{attrs:{"fill-height":""}},[_c('v-flex',[_c('v-flex',{staticClass:"gray--text"},[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),_c('v-flex',{staticClass:"subheading"},[_c('span',{domProps:{"innerHTML":_vm._s(_vm.text)}})])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-da0a4248","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/LabelText.vue
// module id = null
// module chunks = 